import React from "react";
import classNames from "classnames";

export const InfoBox = (props: { children: string; color?: string }) => {
  return (
    <div
      className={classNames(
        "flex items-center rounded text-white text-sm font-bold px-4 py-3 mb-6",
        {
          "bg-blue-600": !props.color || props.color === "blue",
          "bg-green-600": props.color === "green",
        }
      )}
      role="alert"
    >
      <i className="fa fa-info-circle mr-4" />
      <p>{props.children}</p>
    </div>
  );
};
